import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75592 3.57733C10.0814 3.90277 10.0814 4.4304 9.75592 4.75584L4.51184 9.99992L9.75592 15.244C10.0814 15.5694 10.0814 16.0971 9.75592 16.4225C9.43049 16.7479 8.90285 16.7479 8.57741 16.4225L2.74408 10.5892C2.41864 10.2637 2.41864 9.7361 2.74408 9.41066L8.57741 3.57733C8.90285 3.25189 9.43049 3.25189 9.75592 3.57733ZM16.4226 3.57733C16.748 3.90277 16.748 4.4304 16.4226 4.75584L11.1785 9.99992L16.4226 15.244C16.748 15.5694 16.748 16.0971 16.4226 16.4225C16.0972 16.7479 15.5695 16.7479 15.2441 16.4225L9.41074 10.5892C9.08531 10.2637 9.08531 9.7361 9.41074 9.41066L15.2441 3.57733C15.5695 3.25189 16.0972 3.25189 16.4226 3.57733Z"
    />
  </svg>
);

const DoubleLeftIcon = (props) => <Icon component={SVG} {...props} />;

export default DoubleLeftIcon;
